import React from "react";

import { columnsNames } from "../../css/columns";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const ColumsTop = ({ columns, setDescription }) => {
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));
  return (
    <div className="flex items-center justify-center">
      <button
        key={"quantity"}
        style={{
          width: 140,
        }}
        className={`border-x-[0.1px] border-dotted border-[#F3F5F7] w-[140px] flex items-center justify-center`}
        onClick={() => {
          setDescription("quantity");
          // console.log('oto')
        }}
      >
        <div className="w-full justify-center">
          <p className="font-Poppins-SemiBold w-full text-center">Quantité</p>
          <p className="font-Poppins-Light text-center">{""}</p>
        </div>
      </button>

      <button
        key={"impact_percent"}
        style={{
          width: 140,
        }}
        className={`border-x-[0.1px] border-dotted border-[#F3F5F7] w-[140px] flex items-center justify-center`}
        onClick={() => {
          setDescription("impact_percent");
        }}
      >
        <div className="w-full justify-center">
          <p className="font-Poppins-SemiBold w-full text-center">% impact</p>
          <p className="font-Poppins-Light text-center">{""}</p>
        </div>
      </button>

      {/* QUANTITY */}
      {columns.map((current, i) => {
        return (
          <button
            key={`${i}`}
            style={{
              width: impact_indicators.find((target) => target.id === current).width,
            }}
            className={`border-x-[0.1px] border-dotted border-[#F3F5F7] w-[${impact_indicators.find((target) => target.id === current).width}px] flex items-center justify-center`}
            onClick={() => {
              // setDescription(i + 2);
              setDescription(current);
            }}
          >
            {/* {console.log()} */}
            <div className="w-full justify-center">
              <p className="font-Poppins-SemiBold w-full text-center">{impact_indicators.find((target) => target.id === current).name.fr}</p>
              <p className="font-Poppins-Light text-center">
                {"("}
                {impact_indicators.find((target) => target.id === current).ref_unit}
                {")"}
              </p>
            </div>
          </button>
        );
      })}

      {/* VALIDER */}

      <button
        key={"validate"}
        className={`border-x-[0.1px] border-dotted border-[#F3F5F7] w-[100px] flex items-center justify-center`}
        onClick={() => {
          setDescription("validate");
        }}
      >
        <div className="w-full justify-center">
          <p className="font-Poppins-SemiBold w-full text-center">Valider</p>
          <p className="font-Poppins-Light text-center">{""}</p>
        </div>
      </button>
    </div>
  );
};

export default ColumsTop;
